export default "__VITE_ASSET__DhqE6x4B__"